import { App } from '@capacitor/app';
import type VueRouter from 'vue-router';
import { convertUrlToLocation } from '@/common/services/convert-url-to-location';
import type { PlatformResolutionService } from '@/common/services/platform-resolution';
import { makeLogger } from '@/common/services';
import { APP_SCHEME } from '@/common/constants/app-scheme';

const log = makeLogger('mobile', 'deep-link');

function getDomainFromUrl(url: string) {
    try {
        return new URL(url).hostname;
    } catch (e) {
        return null;
    }
}

/**
 * Since URL() constructor doesn't support custom schemes well we have to put in something more suitable.
 */
function prepareUrl(url: string) {
    return url.replace(APP_SCHEME, 'https://');
}

export function subscribeForDeepLinkOpen(router: VueRouter, platformResolutionService: PlatformResolutionService) {
    App.addListener('appUrlOpen', function deepLinkCallback(event) {
        log('appUrlOpen fired', event);

        const url = prepareUrl(event.url);
        const openUrlDomain = getDomainFromUrl(url);
        const location = convertUrlToLocation(url);

        if (location && openUrlDomain !== null) {
            platformResolutionService.forceSetPlatformDomain(openUrlDomain);
            router.push(location);
            log('going to set platform and push location', openUrlDomain, location);
        }
    });
}
